// Legal content (German is the legally binding version). Source: plasto-nord.com
export const LEGAL = {
  impressum: {
    path: "/impressum",
    title: { de: "Impressum", en: "Imprint" },
    updated: "Januar 2026",
    intro: {
      de: "Angaben gemäß § 5 TMG.",
      en: "Information according to § 5 TMG (German Telemedia Act).",
    },
    sections: [
      { h: { de: "Anbieter", en: "Provider" }, p: [
        "PlastoNord GmbH",
        "Max-Planck-Straße 10",
        "27612 Loxstedt",
        "Deutschland",
      ]},
      { h: { de: "Kontakt", en: "Contact" }, p: [
        "Telefon: +49 (0) 4744 927 909 0",
        "E-Mail: anfrage@plasto-nord.com",
      ]},
      { h: { de: "Vertretungsberechtigte Geschäftsführer", en: "Managing Directors" }, list: [
        "Juri Lehn",
        "Maximilian Kriese",
        "Nikita Blinov",
      ]},
      { h: { de: "Handelsregister", en: "Commercial register" }, p: [
        "Eingetragen im Handelsregister des Amtsgerichts Bremen.",
        "Handelsregisternummer: HRB 212161",
      ]},
      { h: { de: "Umsatzsteuer", en: "VAT" }, p: [
        "Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG: DE 263279921",
        "Steuernummer: 60/136/04973",
      ]},
      { h: { de: "Firmensitz", en: "Registered office" }, p: [
        "Rechtlicher Sitz der Gesellschaft: Max-Planck-Straße 10, 27612 Loxstedt, Deutschland",
      ]},
      { h: { de: "Markenhinweis", en: "Trademark notice" }, p: [
        "Folgende Marken sind eingetragene Marken der PlastoNord GmbH oder werden markenrechtlich genutzt:",
      ], list: ["NORDFLEX®", "NORDLON®", "NORDSAP®", "NORDFORM®", "NORDVAX®"], after: [
        "Eine Verwendung ohne ausdrückliche Zustimmung der Rechteinhaber ist nicht gestattet.",
      ]},
      { h: { de: "Haftung für Inhalte", en: "Liability for content" }, p: [
        "Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8–10 TMG sind wir jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.",
      ]},
      { h: { de: "Haftung für Links", en: "Liability for links" }, p: [
        "Unsere Website enthält ggf. Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Für diese fremden Inhalte wird keine Gewähr übernommen.",
      ]},
      { h: { de: "Urheberrecht", en: "Copyright" }, p: [
        "Die durch die PlastoNord GmbH erstellten Inhalte und Werke auf dieser Website unterliegen dem deutschen Urheberrecht.",
      ]},
    ],
  },

  datenschutz: {
    path: "/datenschutz",
    title: { de: "Datenschutzerklärung", en: "Privacy Policy" },
    updated: "Januar 2026",
    intro: {
      de: "Stand: Januar 2026. Maßgeblich ist die deutsche Fassung.",
      en: "Last updated: January 2026. The German version is legally binding.",
    },
    sections: [
      { h: { de: "1. Verantwortlicher", en: "1. Controller" }, p: [
        "Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO):",
        "PlastoNord GmbH, Max-Planck-Straße 10, 27612 Loxstedt, Deutschland",
        "Telefon: +49 (0) 4744 927 909 0",
        "E-Mail: anfrage@plasto-nord.com",
      ]},
      { h: { de: "2. Allgemeine Hinweise zur Datenverarbeitung", en: "2. General information" }, p: [
        "Der Schutz Ihrer personenbezogenen Daten ist uns ein wichtiges Anliegen. Personenbezogene Daten werden auf dieser Website ausschließlich im Rahmen der gesetzlichen Bestimmungen der DSGVO sowie des Telekommunikation-Digitale-Dienste-Datenschutz-Gesetzes (TDDDG) verarbeitet.",
        "Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.",
      ]},
      { h: { de: "3. Hosting der Website", en: "3. Hosting" }, p: [
        "Unsere Website wird bei einem externen Hosting-Dienstleister betrieben. Dabei werden alle Daten, die im Rahmen der Nutzung dieser Website anfallen, auf den Servern des Hosters verarbeitet.",
        "Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an sicherem und effizientem Betrieb der Website). Ein Vertrag zur Auftragsverarbeitung gemäß Art. 28 DSGVO besteht.",
      ]},
      { h: { de: "4. Erhebung beim Besuch der Website", en: "4. Data collection when visiting" }, p: [
        "Beim Aufrufen unserer Website werden durch den Browser automatisch Informationen an den Server übermittelt:",
      ], list: ["IP-Adresse", "Datum und Uhrzeit der Anfrage", "Browsertyp und -version", "Betriebssystem", "Referrer-URL", "Hostname des zugreifenden Rechners"], after: [
        "Diese Daten werden nicht mit anderen Datenquellen zusammengeführt. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO.",
      ]},
      { h: { de: "5. Kontaktaufnahme (Formular / E-Mail / Telefon)", en: "5. Contact" }, p: [
        "Wenn Sie uns über das Anfrageformular, per E-Mail oder telefonisch kontaktieren, werden Ihre Angaben inklusive der Kontaktdaten zwecks Bearbeitung der Anfrage gespeichert.",
        "Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen / Vertrag) sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse).",
      ]},
      { h: { de: "6. Cookies", en: "6. Cookies" }, p: [
        "Unsere Website verwendet technisch notwendige Cookies. Diese sind erforderlich, um die Website korrekt darzustellen und grundlegende Funktionen bereitzustellen.",
        "Rechtsgrundlage: § 25 Abs. 2 Nr. 2 TDDDG, Art. 6 Abs. 1 lit. f DSGVO.",
        "Tracking- oder Marketing-Cookies werden nur nach ausdrücklicher Einwilligung eingesetzt (sofern verwendet).",
      ]},
      { h: { de: "7. Weitergabe von Daten", en: "7. Data transfer" }, p: [
        "Eine Weitergabe personenbezogener Daten erfolgt nur:",
      ], list: [
        "wenn Sie ausdrücklich eingewilligt haben (Art. 6 Abs. 1 lit. a DSGVO)",
        "zur Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO)",
        "aufgrund gesetzlicher Verpflichtungen (Art. 6 Abs. 1 lit. c DSGVO)",
        "bei berechtigtem Interesse (Art. 6 Abs. 1 lit. f DSGVO)",
      ]},
      { h: { de: "8. Speicherdauer", en: "8. Retention period" }, p: [
        "Personenbezogene Daten werden nur so lange gespeichert, wie es für den jeweiligen Zweck erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen.",
      ]},
      { h: { de: "9. Ihre Rechte als betroffene Person", en: "9. Your rights" }, p: [
        "Sie haben jederzeit das Recht auf:",
      ], list: [
        "Auskunft (Art. 15 DSGVO)", "Berichtigung (Art. 16 DSGVO)", "Löschung (Art. 17 DSGVO)",
        "Einschränkung der Verarbeitung (Art. 18 DSGVO)", "Datenübertragbarkeit (Art. 20 DSGVO)",
        "Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)",
      ], after: ["Anfragen richten Sie bitte an: info@plasto-nord.com"]},
      { h: { de: "10. Widerruf Ihrer Einwilligung", en: "10. Withdrawal of consent" }, p: [
        "Eine bereits erteilte Einwilligung zur Datenverarbeitung können Sie jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Verarbeitung bleibt unberührt.",
      ]},
      { h: { de: "11. Beschwerderecht bei der Aufsichtsbehörde", en: "11. Right to complain" }, p: [
        "Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren. Zuständig ist insbesondere die Aufsichtsbehörde Ihres Aufenthaltsortes oder des Firmensitzes.",
      ]},
      { h: { de: "12. Datensicherheit", en: "12. Data security" }, p: [
        "Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre Daten gegen Manipulation, Verlust oder unbefugten Zugriff zu schützen.",
      ]},
      { h: { de: "13. Aktualität und Änderung", en: "13. Updates" }, p: [
        "Diese Datenschutzerklärung hat den Stand Januar 2026. Wir behalten uns vor, sie bei rechtlichen oder technischen Änderungen anzupassen.",
      ]},
    ],
  },

  agb: {
    path: "/agb",
    title: { de: "Allgemeine Geschäftsbedingungen (AGB)", en: "Terms & Conditions" },
    updated: "Januar 2026",
    intro: {
      de: "Stand: Januar 2026. Maßgeblich ist die deutsche Fassung.",
      en: "Last updated: January 2026. The German version is legally binding.",
    },
    sections: [
      { h: { de: "§ 1 Geltungsbereich", en: "§ 1 Scope" }, list: [
        "Diese Allgemeinen Geschäftsbedingungen gelten für sämtliche Verträge, Lieferungen und Leistungen der PlastoNord GmbH (nachfolgend „Verkäufer“) im Bereich Kunststoffgranulate, Compounds, Rohstoffe und verwandte Materialien.",
        "Die AGB gelten ausschließlich gegenüber Unternehmern im Sinne von § 14 BGB, juristischen Personen des öffentlichen Rechts oder öffentlich-rechtlichen Sondervermögen.",
        "Abweichende oder ergänzende Bedingungen des Käufers gelten nur, wenn sie ausdrücklich schriftlich anerkannt wurden.",
      ]},
      { h: { de: "§ 2 Vertragsgegenstand und Materialeigenschaften", en: "§ 2 Subject matter" }, list: [
        "Vertragsgegenstand sind Kunststoffgranulate, Compounds oder sonstige polymerbasierte Rohstoffe gemäß Auftragsbestätigung.",
        "Die angegebenen technischen Daten (z. B. MFI/MVR, Dichte, Shore-Härte, Farbe, Feuchtigkeit, Additive) stellen Richtwerte dar und unterliegen branchenüblichen und technisch unvermeidbaren Toleranzen.",
        "Abweichungen, die innerhalb handelsüblicher Normen, Herstellertoleranzen oder Rohstoffchargen liegen, gelten nicht als Mangel.",
        "Eine Eignung für einen bestimmten Verwendungszweck wird nur bei ausdrücklicher schriftlicher Zusicherung geschuldet.",
      ]},
      { h: { de: "§ 3 Angebote und Vertragsschluss", en: "§ 3 Offers" }, list: [
        "Angebote sind freibleibend und unverbindlich.",
        "Ein Vertrag kommt erst durch schriftliche Auftragsbestätigung oder Lieferung der Ware zustande.",
        "Musterlieferungen dienen ausschließlich der Orientierung und stellen keine Beschaffenheitsgarantie dar.",
      ]},
      { h: { de: "§ 4 Preise und Zahlungsbedingungen", en: "§ 4 Prices & payment" }, list: [
        "Alle Preise verstehen sich netto ab Werk, zzgl. gesetzlicher Umsatzsteuer, Verpackungs-, Transport- und Versicherungskosten.",
        "Zahlungen sind – sofern nicht anders vereinbart – vor Lieferung fällig (Vorkasse).",
        "Bei Zahlungsverzug gelten Verzugszinsen gemäß § 288 Abs. 2 BGB (9 Prozentpunkte über Basiszinssatz).",
        "Der Verkäufer ist berechtigt, Lieferungen zurückzuhalten, solange offene Forderungen bestehen.",
      ]},
      { h: { de: "§ 5 Lieferung, Gefahrübergang, Verpackung", en: "§ 5 Delivery" }, list: [
        "Lieferung erfolgt ab Werk (EXW, Incoterms® 2020), sofern nichts anderes vereinbart ist.",
        "Die Gefahr geht mit Übergabe an Spediteur oder Frachtführer auf den Käufer über.",
        "Granulate werden branchenüblich in Säcken, Big Bags oder Silofahrzeugen geliefert.",
        "Verpackung ist kein Bestandteil der Gewährleistung, sofern sie den Transportzweck erfüllt.",
      ]},
      { h: { de: "§ 6 Untersuchungs- und Rügepflicht (§ 377 HGB)", en: "§ 6 Inspection" }, list: [
        "Der Käufer ist verpflichtet, die Ware unverzüglich nach Anlieferung zu untersuchen.",
        "Offensichtliche Mängel sind spätestens innerhalb von 3 Werktagen schriftlich anzuzeigen.",
        "Verdeckte Mängel sind unverzüglich nach Entdeckung schriftlich anzuzeigen.",
        "Unterbleibt die ordnungsgemäße Untersuchung oder Anzeige, gilt die Ware als genehmigt (§ 377 HGB).",
        "Eine Weiterverarbeitung der Ware gilt als vollständige Abnahme.",
      ]},
      { h: { de: "§ 7 Gewährleistung bei Kunststoffgranulaten", en: "§ 7 Warranty" }, list: [
        "Bei berechtigter Mängelrüge erfolgt Nacherfüllung nach Wahl des Verkäufers durch Ersatzlieferung oder Gutschrift.",
        "Weitergehende Ansprüche, insbesondere Produktions- oder Verarbeitungsschäden, sind ausgeschlossen.",
        "Die Gewährleistungsfrist beträgt 12 Monate ab Gefahrübergang.",
        "Keine Gewährleistung besteht bei: falscher Verarbeitung oder Trocknung; Vermischung mit Fremdmaterial; Verwendung außerhalb der empfohlenen Parameter; natürlichen Farb- oder Chargenschwankungen.",
      ]},
      { h: { de: "§ 8 Haftung", en: "§ 8 Liability" }, list: [
        "Der Verkäufer haftet nur bei Vorsatz und grober Fahrlässigkeit.",
        "Bei einfacher Fahrlässigkeit nur bei Verletzung wesentlicher Vertragspflichten und begrenzt auf den vorhersehbaren Schaden.",
        "Ausgeschlossen sind: Produktionsausfälle, entgangener Gewinn, Folgeschäden durch Weiterverarbeitung.",
        "Das Produkthaftungsgesetz bleibt unberührt.",
      ]},
      { h: { de: "§ 9 Eigentumsvorbehalt", en: "§ 9 Retention of title" }, list: [
        "Die Ware bleibt bis zur vollständigen Zahlung sämtlicher Forderungen Eigentum des Verkäufers.",
        "Der Käufer tritt Forderungen aus Weiterveräußerung bereits jetzt an den Verkäufer ab.",
        "Zugriff Dritter auf Vorbehaltsware ist unverzüglich mitzuteilen.",
      ]},
      { h: { de: "§ 10 Höhere Gewalt", en: "§ 10 Force majeure" }, p: [
        "Lieferverzögerungen oder Leistungsausfälle infolge höherer Gewalt (z. B. Rohstoffmangel, Energiekrisen, behördliche Maßnahmen) berechtigen nicht zu Schadensersatz.",
      ]},
      { h: { de: "§ 11 Anwendbares Recht und Gerichtsstand", en: "§ 11 Governing law" }, list: [
        "Es gilt deutsches Recht, unter Ausschluss des UN-Kaufrechts (CISG).",
        "Gerichtsstand ist – soweit zulässig – der Sitz des Verkäufers.",
        "Erfüllungsort ist ebenfalls der Firmensitz.",
      ]},
      { h: { de: "§ 12 Salvatorische Klausel", en: "§ 12 Severability" }, p: [
        "Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen Regelungen unberührt.",
      ]},
    ],
  },
};
